import { Avatar, Grid } from '@mui/material';
import { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import gfm from 'remark-gfm';
import FollowMeIcons from '../components/FollowMeIcons/FollowMeIcons';
import { config } from '../config/config';


const AbouMe = () => {

    const [aboutText, setAboutText] = useState("");

    useEffect(() => {
        fetch(config.ABOUT_ME_PAGE.ABOUT_ME_CONTENT_PATH)
            .then(response => response.text())
            .then(data => setAboutText(data));
    }, []);

    return (
        <>
            <Grid container spacing={2} sx={{ pt: { xs: 3, md: 4 }, px: { xs: 2, md: 4 }, maxWidth: 1400, mx: 'auto' }}>
                <Grid item xs={12} md={4} lg={3} sx={{ display: 'flex', justifyContent: { xs: 'center', md: 'flex-start' }, alignItems: 'flex-start', pt: { xs: 2, md: 4 } }}>
                  <Avatar
                    alt={config.ABOUT_ME_PAGE.AVATAR_ALT_TAG}
                    src={config.ABOUT_ME_PAGE.AVATAR_SRC}
                    sx={{ width: { xs: 160, sm: 220, md: 280 }, height: { xs: 160, sm: 220, md: 280 } }}
                  />
                </Grid>
                <Grid item xs={12} md={8} lg={9} sx={{ pt: { xs: 1, md: 4 } }}>
                  <ReactMarkdown remarkPlugins={[gfm]} children={aboutText} />
                  <FollowMeIcons />
                </Grid>
            </Grid>            
        </>
    )
};

export default AbouMe;